var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGeneric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1315_8932",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1315_8932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 20.975V17.975H13V15.975H16V12.975H18V15.975H21V17.975H18V20.975H16Z",
    fill: "#181716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 10V8H19V10H4Z",
    fill: "#181716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6V4H19V6H4Z",
    fill: "#181716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00061 15.999H10.5323V18.0029H4.00061V15.999Z",
    fill: "#181716"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7448 12H4.00061V14.0039H13.7448V12Z",
    fill: "#181716"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGeneric);
export default __webpack_public_path__ + "static/media/icon_generic.075afb7f1c5ab5d9e8a02b07d5470420.svg";
export { ForwardRef as ReactComponent };